// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2ub-4","balanceDisclaimer":"posDashboard_balanceDisclaimer__39Tr6"};